export const noticeConstants = {
  ADD_NOTICE_START: "NOTICE_ADD_NOTICE_START",
  ADD_NOTICE_SUCCESS: "NOTICE_ADD_NOTICE_SUCCESS",
  ADD_NOTICE_ERROR: "NOTICE_ADD_NOTICE_ERROR",

  FETCH_NOTICE_START: "NOTICE_FETCH_NOTICE_START",
  FETCH_NOTICE_SUCCESS: "NOTICE_FETCH_NOTICE_SUCCESS",
  FETCH_NOTICE_ERROR: "NOTICE_FETCH_NOTICE_ERROR"
};
